import React, { useEffect } from "react";
import { SsoPageContentMobile } from "../../blocks/ssoPage-content-mobile";
import { AdvantageList } from "../../blocks/advantage-list";
import { SSOPageContent } from "../../blocks/ssoPage-content";
import { CommonPageLink } from "../../blocks/common-page-link";
import { useTranslation } from "react-i18next";
import { Header } from "../../components/Header";
import { ProductBanner } from "../../blocks/product-banner";
import { SSOPageContentSence } from "../../blocks/ssoPage-content-sence";
import { Footer } from "../../components/FooterV2";
import "./styles.less";
import { HomeTryOn } from "../../blocks/home-try-on";
import { Helmet } from "react-helmet";
import { useTimeoutFn } from "react-use";
import { Notice } from "../../components/Notice";

export const SSOPage = () => {
  useEffect(() => {
    // _MEIQIA("subSource", "sub_source_4");
    // _MEIQIA("init");
  }, []);
  // useTimeoutFn(() => {
  //   _MEIQIA("showPanel");
  // }, 30000);
  const { t } = useTranslation();
  const bannerData = {
    title: "learn.ssoPage.banner.title",
    subTitle: "learn.ssoPage.banner.subtitle",
    bannerImg: {
      src: t("learn.ssoPage.banner.img"),
      alt: "多个应用集成单点登录",
    },
    bannerBG: {
      src: "//files.authing.co/authing-website/sso-banner-bg.png",
      alt: "authing",
    },
    hasButton: true,
    docLink: "https://docs.authing.cn/v2/guides/app/sso.html",
  };
  const advantageData = [...Array(3)].map((item, index) => {
    return {
      label: `learn.ssoPage.advantageData.${index}.label`,
      value: `learn.ssoPage.advantageData.${index}.value`,
    };
  });

  const pagesLink = [
    {
      title: t("common.pageLink.comp.title"),
      description: t("common.pageLink.comp.description"),
      imgurl: "/page-link-comp.png",
      jumpLink: "/learn/guard",
      defaultImg: "//files.authing.co/authing-website/page-link-icon-comp.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-comp.svg",
    },
    {
      title: t("common.pageLink.mfa.title"),
      description: t("common.pageLink.mfa.description"),
      imgurl: "/page-link-mfa.png",
      jumpLink: "/mfa",
      defaultImg: "//files.authing.co/authing-website/page-link-icon-mfa.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-mfa.svg",
    },
    {
      title: t("common.pageLink.verify.title"),
      description: t("common.pageLink.verify.description"),
      imgurl: "/page-link-verify.png",
      jumpLink: "/verify",
      defaultImg:
        "//files.authing.co/authing-website/page-link-icon-verify.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-verify.svg",
    },
    {
      title: t("common.pageLink.database.title"),
      description: t("common.pageLink.database.description"),
      imgurl: "/page-link-database-connection.png",
      jumpLink: "/database-connection",
      defaultImg:
        "//files.authing.co/authing-website/page-link-icon-database.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-database.svg",
    },
  ];
  return (
    <div className="sso-page">
      <Helmet>
        <title>
          单点登录SSO-统一身份认证-单点登录平台-Authing身份云以开发者为中心
        </title>
      </Helmet>
      <Header mode="light" hasNotice />
      <ProductBanner {...bannerData} />
      <AdvantageList advantageData={advantageData} />
      <SsoPageContentMobile />
      <SSOPageContent />
      <SSOPageContentSence />
      <CommonPageLink pagesLink={pagesLink} />
      <div className="ssoPage-homeTryOn-bg">
        <HomeTryOn />
      </div>
      {/* <HomeTryOn /> */}
      <Footer />
    </div>
  );
};
